import React from "react";
import "../AboutSection.css";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

import {
    FaShieldAlt,
    FaCloud,
    FaUserShield,
    FaLock,
    FaArrowRight,
    FaCheckCircle,
} from "react-icons/fa";

// Replace with your own cybersecurity illustration
import aboutImg from "../../assets/banner-2.jfif";

const features = [
    "24×7 Security Operations Center (SOC)",
    "Advanced Threat Detection & Response",
    "Cloud & Network Security Solutions",
    "Risk Assessment & Compliance Services",
];

const AboutSection = () => {
    return (
        <section className="home-about-section">

            <div className="container">

                <motion.div
                    className="home-about-content"
                    initial={{ opacity: 0, y: 60 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                >

                    <span className="home-section-tag">
                        <FaShieldAlt />
                        About BlueLotus
                    </span>

                    <h2>
                        Securing Businesses with
                        <span> Intelligent Cybersecurity Solutions</span>
                    </h2>

                    <p>
                        <strong>BlueLotus Infrasafety Projects Private Limited</strong> is a
                        trusted cybersecurity company committed to protecting organizations
                        from modern cyber threats. We deliver enterprise-grade security
                        solutions that safeguard digital infrastructure, cloud environments,
                        applications, and critical business data.
                    </p>

                    <p>
                        Our experienced security professionals help businesses build resilient
                        cyber defenses through proactive monitoring, vulnerability
                        assessments, security consulting, compliance, and incident response
                        services.
                    </p>

                    <div className="home-feature-list">

                        {features.map((item, index) => (

                            <div
                                className="home-feature-item"
                                key={index}
                            >
                                <FaCheckCircle />

                                <span>{item}</span>

                            </div>

                        ))}

                    </div>

                    <div className="home-service-cards">

                        <div className="home-service-card">

                            <FaCloud className="home-icon" />

                            <div>

                                <h4>Cloud Security</h4>

                                <p>
                                    Protect cloud workloads and hybrid infrastructure.
                                </p>

                            </div>

                        </div>

                        <div className="home-service-card">

                            <FaUserShield className="home-icon" />

                            <div>

                                <h4>Identity Protection</h4>

                                <p>
                                    Secure user identities using Zero Trust and MFA.
                                </p>

                            </div>

                        </div>

                        <div className="home-service-card">

                            <FaLock className="home-icon" />

                            <div>

                                <h4>Data Protection</h4>

                                <p>
                                    Keep confidential business information protected from cyber attacks.
                                </p>

                            </div>

                        </div>

                    </div>

                    <div className="home-about-buttons">

                        <a
                            href="/about"
                            className="primary-btn"
                        >
                            Read More
                            <FaArrowRight />
                        </a>

                        <a
                            href="/contact"
                            className="secondary-btn"
                            style={{ color: "black", borderRadius:"40px", borderColor:"black" }}>
                            Contact Experts
                        </a>

                    </div>

                </motion.div>

            </div>

        </section>
    );
};

export default AboutSection;